import { AlcoholSellingStatus } from '@shared/gql/document-nodes'

export const getAlcoholSellingAllowed = (alcoholSellingAllowed: AlcoholSellingStatus): boolean =>
  alcoholSellingAllowed === AlcoholSellingStatus.Allowed
